import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { getQuestionById, updateQuestion } from "../../features/jobSlice";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const JobQuestionEdit = () => {
  const { singleQuestion } = useAppSelector((state) => state.job);
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const [question, setQuestion] = React.useState("");
  const [answer, setAnswer] = React.useState("");
  const [options, setOptions] = useState<{ options: string }[]>([
    { options: "Yes" },
    { options: "No" },
  ]);

useEffect(() => {
  const fetchQuestion = async () => {
    try {
      const result = await dispatch(getQuestionById(id)).unwrap();
      setQuestion(result.jobQuestion);
      setAnswer(result.answer);
      setOptions(result.options);
    } catch (error) {
      console.error("Fetch question error:", error);
      toast.error("Failed to fetch question: " + (error));
    }
  };

  fetchQuestion();
}, [id, dispatch]);


  const handleSaveQuestion = () => {
    const data = {
      jobQuestion: question,
      answer: answer,
      options: options,
      id: singleQuestion.id,
    };
    
    dispatch(updateQuestion(data))
      .unwrap()
      .then(() => {
        setQuestion("");
        setAnswer("");
        setOptions([{ options: "Yes" }, { options: "No" }]);
        navigate(`/job-settings/job-application/${singleQuestion.category_id}`);
        toast.success("Question updated successfully!");
      })
      .catch((error) => {
        toast.error("Failed to update question: " + error.message);
      });
  };
 

  if (!singleQuestion) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <p>Loading...</p>
      </div>
    );
  }

  console.log(singleQuestion.answer);

  return (
    <div>
      <div className="form-group">
        <label className="mb-2">Enter Question</label>
        <textarea
          className="form-control rounded-0"
          value={question}
          name="question"
          onChange={(e) => setQuestion(e.target.value)}
        ></textarea>
      </div>

      <div className="form-group mt-3">
        <label>Select Answer</label>
        <div>
          <input
            type="radio"
            className="form-check-input"
            name="answer"
            value="Yes"
            checked={answer === "Yes"}
            onChange={(e) => setAnswer(e.target.value)}
          />{" "}
          Yes
          <input
            type="radio"
            className="form-check-input ms-3"
            name="answer"
            value="No"
            checked={answer === "No"}
            onChange={(e) => setAnswer(e.target.value)}
          />{" "}
          No
        </div>
      </div>

      <Button variant="secondary" className="text-white rounded-0" onClick={handleSaveQuestion}>
        Save
      </Button>
    </div>
  );
};

export default JobQuestionEdit;
